module.exports = __webpack_public_path__ + "static/img/qrcode.dfc56f8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/qrcode.jpeg
// module id = wQ/o
// module chunks = 1